import { get } from '../../../Utils/helpers';
import {
  getAIAnalysisDescriptionFromLevel,
  getAIIsFalsePositiveFromLevel,
} from '../../../Utils/TestResultsMethods';

export const defaultType = {
  getTitle: (tr) => tr.name,
  getContentMessage: (tr) => get(tr, 'extraInfo.error.message'),
  getField: (tr, field) => get(tr, field),
  getExtraActions: (tr) => [],
  getIT: (tr) => get(tr, 'it'),
  getStatus: (tr) => get(tr, 'status'),
  getTransformedData: (tr) => tr,
  getName: (tr) => get(tr, 'name'),
  getExtraData: (tr) => ({}),
  getAIAnalysisDescription: (tr) => getAIAnalysisDescriptionFromLevel(tr),
  getAIIsFalsePositive: (tr) => getAIIsFalsePositiveFromLevel(tr),
};
